import { createAction, props } from '@ngrx/store';
import { ActionResponse } from 'src/app/models/action-response';
import { BillingitemReplaceRequest } from 'src/app/models/billingitem';
import { ServiceAlias } from 'src/app/models/service';
import { ReplaceBillingitemsDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-billingitems-wizard/activation-step/replacebillingitems-due-date-info';
import { ReplaceBillingitemsInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-billingitems-wizard/init-step/init-step';

export const selectInitStep = createAction(
  '[V26Catalog Page] Select Init Replace Billingitems Information Step',
  props<{ initStep: ReplaceBillingitemsInitStepV26 }>(),
);

export const selectDueDatesStep = createAction(
  '[V26Wizard Due Date Step] Select Replace Billingitems Due Date Step',
  props<{ dueDatesStep: ReplaceBillingitemsDueDatesV26 }>(),
);

export const selectServiceStep = createAction(
  '[V26Wizard Billing account Step] Select Replace Billingitems Billing account Step',
  props<{ serviceStep: ServiceAlias[] }>(),
);

export const deleteServiceStep = createAction('[V26Wizard Billing account Step] Delete Replace Billingitems Billing account Step');

export const exitReplaceBillingitemsWizard = createAction('[V26ReplaceBillingitems Wizard Page] Exit Replace Billingitems Wizard');

export const destroyWizard = createAction('[V26ReplaceBillingitems Wizard Page] Destroy Wizard');

export const createNewReplaceBillingitems = createAction(
  '[V26Wizard Confirmation Step] Create Replace Billingitems Information Step',
  props<{ request: BillingitemReplaceRequest }>(),
);

export const createNewReplaceBillingitemsSuccess = createAction(
  '[V26Wizard Confirmation Step] Create Replace Billingitems Information Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewReplaceBillingitemsFail = createAction(
  '[V26Wizard Confirmation Step] Create Replace Billingitems Information Step Fail',
  props<{ errorMessage: string }>(),
);
